/**
 * Nomlai® – sanftes Einblenden beim Scrollen.
 * Laeuft nur, wenn der Besucher keine reduzierte Bewegung eingestellt hat.
 */
(() => {
  "use strict";

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const showAll = () =>
    document
      .querySelectorAll("[data-nml-reveal]")
      .forEach((el) => el.classList.add("nml-visible"));

  if (reduce || !("IntersectionObserver" in window)) {
    showAll();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("nml-visible");
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: "0px 0px -8% 0px", threshold: 0.05 }
  );

  const observe = () =>
    document
      .querySelectorAll("[data-nml-reveal]:not(.nml-visible)")
      .forEach((el) => observer.observe(el));

  observe();

  // Theme-Editor: nach jedem Neuladen einer Section erneut beobachten
  document.addEventListener("shopify:section:load", observe);
})();
